var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    { staticClass: "conteneurLead", attrs: { flat: "" } },
    [
      _c(
        "v-card-title",
        {
          staticClass: "primary white--text",
          staticStyle: { height: "52px", padding: "0px" }
        },
        [
          _c(
            "v-btn",
            {
              attrs: { icon: "" },
              on: {
                click: function($event) {
                  return _vm.cancelDialog()
                }
              }
            },
            [_c("v-icon", { staticClass: "white--text" }, [_vm._v("close")])],
            1
          ),
          _vm._v(" "),
          _c("span", { staticClass: "title" }, [
            _vm._v(
              _vm._s(_vm.$t("statSuperv24")) +
                " " +
                _vm._s(_vm.nameAgentComputed)
            )
          ]),
          _vm._v(" "),
          _c("v-spacer")
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-card-text",
        [
          _c(
            "v-flex",
            { attrs: { xs12: "" } },
            [
              _vm.loading
                ? _c(
                    "v-card",
                    { staticClass: "mb-3", attrs: { height: "400px" } },
                    [
                      _c(
                        "v-card-text",
                        { staticClass: "text-xs-center pt-5" },
                        [
                          _c("v-progress-circular", {
                            staticClass: "primary--text",
                            attrs: { indeterminate: "" }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-flex",
            { attrs: { xs12: "" } },
            [
              !_vm.loading
                ? _c(
                    "v-card",
                    { staticClass: "mb-3" },
                    [
                      _c(
                        "v-flex",
                        { attrs: { "d-flex": "", xs12: "" } },
                        [
                          _c(
                            "v-layout",
                            { attrs: { row: "", wrap: "" } },
                            [
                              _c(
                                "v-flex",
                                { attrs: { "d-flex": "", md8: "" } },
                                [
                                  _c(
                                    "v-flex",
                                    { attrs: { xs12: "" } },
                                    [
                                      _c("highcharts", {
                                        attrs: { options: _vm.agentOccupation }
                                      }),
                                      _vm._v(" "),
                                      _c("br"),
                                      _vm._v(" "),
                                      _c("highcharts", {
                                        attrs: { options: _vm.agentStatus }
                                      }),
                                      _vm._v(" "),
                                      _c("br"),
                                      _vm._v(" "),
                                      _c("highcharts", {
                                        attrs: { options: _vm.agentConnexions }
                                      }),
                                      _vm._v(" "),
                                      _c("br"),
                                      _vm._v(" "),
                                      _c(
                                        "v-flex",
                                        { attrs: { "d-flex": "", sc12: "" } },
                                        [
                                          _c(
                                            "v-flex",
                                            {
                                              attrs: {
                                                "d-flex": "",
                                                xs12: "",
                                                md4: "",
                                                "child-flex": ""
                                              }
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass: "text-md-center"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t("statSuperv25")
                                                    ) +
                                                      " : " +
                                                      _vm._s(
                                                        _vm.afficheTotalTempsChat
                                                      )
                                                  )
                                                ]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-flex",
                                            {
                                              attrs: {
                                                "d-flex": "",
                                                xs12: "",
                                                md4: "",
                                                "child-flex": ""
                                              }
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass: "text-md-center"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t("statSuperv26")
                                                    ) +
                                                      " : " +
                                                      _vm._s(_vm.moyenChatMax)
                                                  )
                                                ]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-flex",
                                            {
                                              attrs: {
                                                "d-flex": "",
                                                xs12: "",
                                                md4: "",
                                                "child-flex": ""
                                              }
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass: "text-md-center"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t("statSuperv27")
                                                    ) +
                                                      " : " +
                                                      _vm._s(
                                                        _vm.afficheTotalTempsMoyenChats
                                                      )
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                {
                                  attrs: {
                                    "d-flex": "",
                                    xs12: "",
                                    md4: "",
                                    "child-flex": ""
                                  }
                                },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      staticClass: "text-md-center",
                                      attrs: { xs12: "" }
                                    },
                                    [
                                      _c("p", [
                                        _vm._v(_vm._s(_vm.$t("statSuperv23"))),
                                        _c("strong", [
                                          _vm._v(
                                            _vm._s(_vm.afficheTotalTempsRef)
                                          )
                                        ])
                                      ]),
                                      _vm._v(" "),
                                      _c("highcharts", {
                                        attrs: {
                                          options: _vm.productivityAgent
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.$t("connectionRate")) +
                                            " : " +
                                            _vm._s(_vm.tauxProductivity1) +
                                            " % (" +
                                            _vm._s(
                                              _vm.afficheTotalTempsConnexion
                                            ) +
                                            ")"
                                        )
                                      ]),
                                      _c("br"),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.$t("agentsActivity")) +
                                            " : " +
                                            _vm._s(_vm.tauxProductivity2) +
                                            " % (" +
                                            _vm._s(
                                              _vm.afficheTotalTempsPresence
                                            ) +
                                            ")"
                                        )
                                      ]),
                                      _c("br"),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.$t("agentsInactivity")) +
                                            " : " +
                                            _vm._s(_vm.tauxProductivity3) +
                                            " % (" +
                                            _vm._s(
                                              _vm.afficheTotalTempsHorsProd
                                            ) +
                                            ")"
                                        )
                                      ]),
                                      _c("br"),
                                      _vm._v(" "),
                                      _c("highcharts", {
                                        attrs: { options: _vm.activityAgent }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticClass: "text-md-center" },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$t("statSuperv28")) +
                                              " : (" +
                                              _vm._s(
                                                _vm.afficheTotalTempsPresence
                                              ) +
                                              ")"
                                          )
                                        ]
                                      ),
                                      _c("br"),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticClass: "text-md-center" },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$t("statSuperv29")) +
                                              " : " +
                                              _vm._s(_vm.afficheTotalTempsBusy)
                                          )
                                        ]
                                      ),
                                      _c("br"),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticClass: "text-md-center" },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$t("statSuperv30")) +
                                              " : " +
                                              _vm._s(
                                                _vm.afficheTotalTempsPartielleActivity
                                              )
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: {
            persistent: "",
            "min-width": "640px",
            "max-width": "800px",
            scrollable: !_vm.$vuetify.breakpoint.smAndDown,
            fullscreen: _vm.$vuetify.breakpoint.smAndDown
          },
          model: {
            value: _vm.dialogChat,
            callback: function($$v) {
              _vm.dialogChat = $$v
            },
            expression: "dialogChat"
          }
        },
        [
          _c(
            "v-card",
            { attrs: { flat: "" } },
            [
              _c(
                "v-card-title",
                {
                  staticClass: "primary white--text",
                  staticStyle: { height: "52px", padding: "0px" }
                },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "" },
                      on: {
                        click: function($event) {
                          return _vm.cancelDialogChat()
                        }
                      }
                    },
                    [
                      _c("v-icon", { staticClass: "white--text" }, [
                        _vm._v("close")
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("span", { staticClass: "title" })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-text",
                {
                  staticClass: "pa-0",
                  style: !_vm.$vuetify.breakpoint.smAndDown
                    ? "height: calc(100vh - 210px);"
                    : ""
                },
                [
                  _vm.chatDialog.id
                    ? _c("wz-histo-chats", {
                        attrs: {
                          params: "visId=" + _vm.chatDialog.id,
                          numChatsTotal: String(0),
                          chatHeight: "100%",
                          type: "satisfaction",
                          scroll: ""
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-418f935f", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-418f935f","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/watcheezy/WzAgentsOccupationDay.vue
// module id = null
// module chunks = 